import { Box, Container, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { HeroText } from "components/shared/Typography";
import NeedHelp from "components/upload/NeedHelp";
import { colors } from "theme";

import Requirements from "./components/Requirements";
import FileUpload from "./components/Upload";

const useStyles = makeStyles(() => ({
  container: {
    "& .MuiInputLabel-filled.Mui-focused": {
      color: colors.semantic.positive,
    },
    "& .MuiFilledInput-underline.Mui-focused:after": {
      borderColor: colors.semantic.positive,
    },
  },
}));

const UploadDesigns = () => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      flexDirection="column"
      width={1}
      className="upload-designs-container"
    >
      <Container>
        <Box
          pt={{ xs: 3, md: 4, lg: 5 }}
          pb={{ xs: 4, sm: 5, md: 4, lg: 7 }}
          pl={{ xs: 0, sm: 3 }}
        >
          <HeroText mb={{ xs: 3, md: 4, lg: 5 }}>Upload Designs</HeroText>
          <Grid container spacing={6}>
            <Grid item md={8} className={classes.container}>
              <FileUpload />
            </Grid>
            <Grid item md={4}>
              <Box mb={5}>
                <Requirements />
              </Box>
              <NeedHelp />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default UploadDesigns;
